import Vue from 'vue'
import AlbumListing from './containers/AlbumListing.vue'

if ( document.getElementById('list-albums-container') ) {
	new Vue({
		el: '#list-albums-container',
		data() {
			return window.$$albumListingData;	
		},
		render: h => h(AlbumListing)
	})
}


// WEBPACK FOOTER //
// ./src/main.js